import {
  LayoutListDefinition,
  LAYOUT_LIST,
  QUESTION_SEQUENCE,
  QUIZ_CHOICE,
  CAROUSEL,
  CarouselDefinition
} from '../items';
import { QuestionSequenceDefinition } from '../items/question-sequence/QuestionSequence';
import { Translator } from '../Translator';
import { AnswerButtonHelper } from './itemHelpers/AnswerButtonHelpers';
import { CardHelper } from './itemHelpers/CardHelper';
import { TextHelper } from './itemHelpers/TextHelper';
import { ItemOfType } from './itemHelpers/types';
import { translate } from './translate';
import { isMobile } from 'react-device-detect';
import { useEditorStore } from '~/shell/Store';

export const Cards6: Translator = sequence => {
  const { editorMode } = useEditorStore.getState();

  const cardsList = {
    type: LAYOUT_LIST,
    id: `${sequence.id}.cardlist`,
    values: {
      orientation: 'row',
      align: 'center',
      padded: true
    },
    items: [
      {
        id: `${sequence.id}.questionsequence`,
        type: QUESTION_SEQUENCE,
        values: void {},
        items: []
      } as QuestionSequenceDefinition
    ]
  } as LayoutListDefinition;

  const textItems: unknown[][] = [];

  const mainList = {
    type: LAYOUT_LIST,
    id: `${sequence.id}.list`,
    values: {
      orientation: 'column',
      align: 'center',
      padded: true
    },
    items: []
  } as LayoutListDefinition;

  const root = translate(sequence, item => {
    if (item.__typename === 'Question') {
      const _item = item as ItemOfType<'Question'>;

      if (editorMode) {
        _item.appear = 0;
      }

      cardsList.items[0].items.push(
        CardHelper(_item, {
          height: 'unset',
          width: editorMode ? '360px' : '269px',
          padding: '0px',
          isImageDecorative: true,
          enableAnimationPause: true,
          extraItems: [
            {
              id: `${item.id}.quiz`,
              type: QUIZ_CHOICE,
              values: {
                title: item?.title?.includes('?')
                  ? item.title
                  : item?.body?.includes('?')
                    ? item.body
                    : '',
                ...(editorMode ? { maxLength: 2 } : {}),
                weNeedToUseOwnFeedback: true
              },
              items: AnswerButtonHelper({
                group: item.id,
                items: item.items,
                linkedAudioId: item.audios?.[0]?.id,
                llamaSurvey: item.llamaSurvey,
                question: item.title || ''
              })
            }
          ]
        })
      );
    } else if (item.__typename === 'Card') {
      const _item = item as ItemOfType<'Card'>;

      if (editorMode) {
        _item.appear = 0;
      }

      cardsList.items[0].items.push(
        CardHelper(_item, {
          height: 'unset',
          width: editorMode ? '360px' : '269px',
          padding: '0px',
          isImageDecorative: true,
          enableAnimationPause: true
        })
      );
    } else if (item.__typename === 'Text') {
      textItems.push(TextHelper(item as ItemOfType<'Text'>));

      mainList.items = [
        {
          type: LAYOUT_LIST,
          id: `${sequence.id}.list`,
          values: {
            orientation: 'column',
            align: 'top',
            padded: false
          },
          items: TextHelper(item as ItemOfType<'Text'>)
        } as LayoutListDefinition
      ];
    }

    return null;
  });

  if (editorMode) {
    root.items.push({
      type: LAYOUT_LIST,
      id: `${sequence.id}.list`,
      values: {
        orientation: 'column',
        align: 'top',
        padded: true
      },
      items: [...mainList.items]
    } as LayoutListDefinition);

    root.items.push({
      type: CAROUSEL,
      id: `${sequence.id}.carousel`,
      values: {
        variant: 'horizontal',
        showProgressBar: false,
        cssStylesForItem: {
          'place-self': 'flex-end',
          height: '80%'
        },
        itemType: 'QUESTION'
      },
      items: cardsList.items[0].items
    } as CarouselDefinition);
  } else if (isMobile && cardsList?.items[0]?.items) {
    const textData = textItems[0] || [];

    root.items.push({
      type: LAYOUT_LIST,
      id: `${sequence.id}.cardlist`,
      values: {
        orientation: 'column',
        align: 'center',
        padded: true
      },
      items: [
        ...textData,
        {
          id: `${sequence.id}.questionsequence`,
          type: QUESTION_SEQUENCE,
          values: void {},
          items: [
            {
              type: CAROUSEL,
              id: `${sequence.id}.carousel`,
              values: {
                variant: 'horizontal'
              },
              items: cardsList.items[0].items
            } as CarouselDefinition
          ]
        } as QuestionSequenceDefinition
      ]
    } as LayoutListDefinition);
  } else {
    mainList.items.push(cardsList);

    if (mainList.items.length > 1) {
      mainList.items.push({
        type: LAYOUT_LIST,
        id: `${sequence.id}.blank`
      } as LayoutListDefinition);
    }

    root.items.push(mainList);
  }

  return root;
};
